import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bookSession } from '../actions/sessionsBookingActions';
import { bookingSessionEventStatuses } from '../utils/constants';

import './styles/BookingModal.scss';
import InviteFriendsToBookingComponent from './InviteFriendsToBookingComponent';

const InviteFriendsToSessionBookingModal = ({
  modalData,
  bookSession: bookSessionFunc,
  bookingFailure,
  bookingError
}) => {
  const {
    bookingsNumber,
    sessionEventId,
    eventDate,
    sessionName,
    eventLocation,
    eventClubName,
    refreshAction,
    inviteFriendsCount
  } = modalData;

  return (
    <InviteFriendsToBookingComponent
      inviteFriendsCount={ inviteFriendsCount }
      actionFunction={ friendsEmails =>
        bookSessionFunc(
          bookingsNumber,
          sessionEventId,
          eventDate,
          sessionName,
          eventLocation,
          eventClubName,
          refreshAction,
          friendsEmails
        )
      }
      bookingFailure={ bookingFailure }
      bookingError={ bookingError }
      emailsRequired={ true }
    />
  );
};

InviteFriendsToSessionBookingModal.propTypes = {
  modalData: PropTypes.shape({
    sessionEventId: PropTypes.number,
    bookingsNumber: PropTypes.number,
    eventDate: PropTypes.string,
    sessionName: PropTypes.string,
    eventLocation: PropTypes.string,
    eventClubName: PropTypes.string,
    refreshAction: PropTypes.func,
    inviteFriendsCount: PropTypes.number
  }),
  bookingError: PropTypes.string,
  bookingFailure: PropTypes.bool,
  bookSession: PropTypes.func
};

InviteFriendsToSessionBookingModal.defaultProps = {
  modalData: {
    sessionName: '',
    eventLocation: '',
    eventDate: '',
    bookingsNumber: 2,
    sessionEventId: null,
    inviteFriendsCount: 1
  },
  bookingError: '',
  bookingFailure: false,
  bookSession: () => {}
};

const mapStateToProps = state => ({
  bookingError: state.sessionEventBooking.error,
  modalData: state.modals.modalData,
  bookingFailure:
    state.sessionEventBooking.status === bookingSessionEventStatuses.FAILED
});

const mapDispatchToProps = dispatch => ({
  bookSession: (
    bookingsNumber,
    sessionEventId,
    eventDate,
    sessionName,
    eventLocation,
    eventClubName,
    refreshAction,
    friendsEmails
  ) =>
    dispatch(
      bookSession(
        bookingsNumber,
        sessionEventId,
        eventDate,
        sessionName,
        eventLocation,
        eventClubName,
        refreshAction,
        friendsEmails
      )
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(
  InviteFriendsToSessionBookingModal
);



// WEBPACK FOOTER //
// ./src/modals/InviteFriendsToSessionBookingModal.js